/* eslint-disable */
export default {
    ABOUT: 'About',
    MAP: 'Map',
    FAQ: 'FAQ',
    CONTACT: 'Contact',
    PARTNERS: 'Partners',
    LOGIN: 'Login',
    TITLE1: 'Guide your visitors',
    TITLE2: 'like never before',
    DESC1: 'Communicate',
    DESC1_1: 'what',
    DESC1_2: 'when',
    DESC1_3: 'where',
    DESC1_4: 'with a single QR code',
    AND: 'and',
    DESC2: 'A professional solution available to everyone',
    ACTION1: 'BOOK A FREE DEMO',
    ACTION2: 'Create it yourself',
    DEMO1: 'Demo: Cabin network',
    DEMO2: 'Demo: Theme park',
    DEMO3: 'Demo: Job fair',
    DEMO4: 'Demo: Conference',
    DEMO1_TITLE: 'TOURISM',
    DEMO2_TITLE: 'PARKS',
    DEMO3_TITLE: 'EVENTS',
    DEMO4_TITLE: 'VENUES',
    BOX1_TITLE: 'Convenience',
    BOX1_DESC: 'Provide the perfect on-site experience without any app installation',
    BOX2_TITLE: 'Speed',
    BOX2_DESC: 'Have everything ready within a few moments and save time with the organization',
    BOX3_TITLE: 'Power',
    BOX3_DESC: 'Easily create the most powerful apps and interactive maps for your visitors',
    ECO1: 'Print less',
    ECO1_DESC: 'Every day millions of leaflets are used and thrown away. Try our digital solution now',
    MAP_TITLE: 'Interactive map',
    MAP_DESC: 'Create the best maps on the internet in our builder',
    MAP_DESC2: 'You can visualize anything',
    MAP_TYPE1: 'CLASSIC',
    MAP_TYPE2: 'INDOOR',
    MAP_TYPE3: 'ARTISTIC',
    MAP_TYPE4: 'IMAGE',
    TRY_ACTION: 'TRY IT OUT',
    FREQUENTLY_ASKED_QUESTIONS: 'Frequently asked questions',
    FAQ_DESC1: 'See what event organizers and venue managers wonder about.',
    FAQ_DESC2: 'Feel free to contact us for other questions',
    Q1: 'What makes this solution unique?',
    A1: 'It feels like a native app, but it requires no installation. It also comes with the best interactive map builder on the market. Creating professional-looking applications and interactive maps was limited to companies with big budgets. Now you can do it yourself. Within moments you will be able to create a perfect guide and visualisation for your visitors.',
    Q2: 'Is my event/venue big enough for this solution?',
    A2: 'Our solution comes in handy everywhere where you wonder how to guide your visitors. All the features of Mapheim are optional, so for instance, you can use it just to display the program and basic information. And if your event or venue grows, you can use more features later on.',
    Q3: 'Can I use an interactive map without the app?',
    A3: 'Yes, you can just create your interactive map and then embed it into your existing website or app. You can also use it as a standalone product, it is up to you.',
    Q4: 'What is the time and cost?',
    A4: 'It can take you just minutes to set up your first on-site application in our editor. You can also use the map builder yourself, but usually, we help our customers with creating the best possible map. The cost primarily depends on the amount of visitors, the type of event, and the amount of help from our side.  Please contact us to discuss your case.',
    Q5: 'How does it differentiate from a classical website?',
    A5: 'There is a difference between using a website to attract visitors to your place, versus guiding them once they are there. You have the opportunity to give them the best possible experience by providing the right information in a structured manner and eventually upselling more services. Mapheim is fully optimized for this use case and can be used perfectly on mobile devices.',
    CONTACT_TITLE: 'Contact',
    CONTACT_HELLO: 'Say hello to Jan',
    CONTACT_DESC: 'He can answer your questions and help you set up your first on-site application and map',
    EMAIL: 'Email',
    EMAIL_NOT_VALID: 'Email is not valid',
    MESSAGE: 'Message',
    SEND_ACTION: 'SEND',
    MESSAGE_RECEIVED: 'Thank you for your message and we will contact you shortly',
    MESSAGE_ERROR: 'Unfortunately, we could not send your message. Please contact me directly using Linkedin or email.',
    CUSTOMERS_TITLE: 'Customers',
    NORWAY: 'Norway',
    DENMARK: 'Denmark',
    CZECHIA: 'Czechia',
    SLOVAKIA: 'Slovakia',
    FAROE_ISLANDS: 'Faroe Islands',
    PARTNERS_TITLE: 'Partners',
    TRONDHEIM_ON_MAP: 'Map of Trondheim',
    FOOTER1: 'Get your app',
    FOOTER2: 'and map today',
    MADE_IN_NORWAY: 'MADE IN NORWAY',
    ADMIN_CALL: 'Login',
    TRIAL_ACCESS: 'Trial access'
};
